export enum RequestStatusEnum {
    evaluation = 0,
    accepted = 1,
    correction = 2,
    canceled = 3,
    corrected = 4,
    outdated = 5,
    /**
     * Aprovada pela triagem e aguardando a assinatura do responsável pelo formulário
     * digital. Ainda não é processo: ele é aberto quando o responsável assina.
     */
    awaitingSignature = 6
}
